// O shell do portal: cabeçalho com a marca e o nome do parceiro, barra de
// navegação INFERIOR (mobile-first, como o sistema) com três destinos.
import { type ReactNode } from 'react';
import { NavLink } from 'react-router';
import Marca from './Marca';
import { lerCarrinho } from '../lib/carrinho';
import { useSessao } from '../lib/sessao';

const ITENS = [
  { para: '/', rotulo: 'Catálogo' },
  { para: '/carrinho', rotulo: 'Carrinho' },
  { para: '/pedidos', rotulo: 'Pedidos' },
];

export default function Layout({ children }: { children: ReactNode }) {
  const { cadastro, sair } = useSessao();
  const noCarrinho = lerCarrinho().length;

  return (
    <div className="flex min-h-svh flex-col bg-ink">
      <header className="flex items-center justify-between gap-3 border-b border-edge px-4 py-3">
        <div className="flex min-w-0 items-center gap-3">
          <Marca className="h-6 w-auto text-signal" />
          <div className="min-w-0">
            <p className="truncate text-sm font-bold leading-tight">{cadastro?.nome}</p>
            <p className="text-[0.625rem] uppercase tracking-wide text-dim">
              Portal do parceiro · desconto {String(cadastro?.desconto_pct ?? '').replace('.', ',')}%
            </p>
          </div>
        </div>
        <button type="button" className="text-xs text-dim underline" onClick={() => void sair()}>
          sair
        </button>
      </header>

      <main className="mx-auto w-full max-w-3xl flex-1 p-4 pb-24">{children}</main>

      <nav className="fixed inset-x-0 bottom-0 border-t border-edge bg-panel pb-[env(safe-area-inset-bottom)]">
        <div className="mx-auto flex max-w-3xl">
          {ITENS.map((i) => (
            <NavLink key={i.para} to={i.para} end={i.para === '/'}
                     className={({ isActive }) =>
                       `flex-1 py-3 text-center text-xs font-bold ${
                         isActive ? 'text-paper' : 'text-dim'}`}>
              {i.rotulo}
              {i.para === '/carrinho' && noCarrinho > 0 && (
                <span className="ml-1 inline-block bg-signal px-1.5 text-[0.625rem] text-paper">
                  {noCarrinho}
                </span>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
